export type SocialCategory = {
  SOCIAL_MEDIA: 'socialMedia';
  MESSAGING: 'messaging';
  TRANSLATING: 'translating';
  COMMUNICATION: 'communication';
};

export type SocialConfigItem = {
  id: SocialCategory[keyof SocialCategory];
  titleKey: string;
  values: {
    id: string;
    name: string;
    iconUrl: string;
    url: string;
  }[];
};

export const socialConfig: Record<string, SocialConfigItem> = {
  socialMedia: {
    id: 'socialMedia',
    titleKey: 'shared.share.social.social_media_title',
    values: [
      {
        id: 'facebook',
        name: 'Facebook',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/facebook.svg',
        url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}',
      },
      {
        id: 'linkedin',
        name: 'LinkedIn',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/linkedin.svg',
        url: 'https://www.linkedin.com/sharing/share-offsite/?url={{url}}',
      },
      {
        id: 'twitter',
        name: 'Twitter',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/twitter.svg',
        url: 'https://twitter.com/intent/tweet?url={{url}}',
      },
      {
        id: 'pinterest',
        name: 'Pinterest',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/pinterest.svg',
        url: 'https://pinterest.com/pin/create/button/?url={{url}}',
      },
      {
        id: 'reddit',
        name: 'Reddit',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/reddit.svg',
        url: 'https://www.reddit.com/submit?url={{url}}',
      },
      {
        id: 'pocket',
        name: 'Pocket',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/pocket.svg',
        url: 'https://getpocket.com/save?url={{url}}',
      },
      {
        id: 'threads',
        name: 'Threads',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/threads.svg',
        url: 'https://www.threads.net/share?url={{url}}',
      },
      {
        id: 'mix',
        name: 'Mix',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/mix.svg',
        url: 'https://www.addtoany.com/add_to/mix?linkurl={{url}}',
      },
      {
        id: 'mastodon',
        name: 'Mastodon',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/mastodon.svg',
        url: 'https://toot.kytta.dev/?text={{url}}',
      },
      {
        id: 'bluesky',
        name: 'Bluesky',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/bluesky.svg',
        url: 'https://bsky.app/intent/compose?text={{url}}',
      },
    ],
  },
  messaging: {
    id: 'messaging',
    titleKey: 'shared.share.social.messaging_title',
    values: [
      {
        id: 'mailru',
        name: 'Mail.ru',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/mail-ru.svg',
        url: 'https://connect.mail.ru/share?share_url={{url}}',
      },
      {
        id: 'email',
        name: 'Email',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/e-mail.svg',
        url: 'mailto:?subject={{name}}&body={{url}}',
      },
      {
        id: 'messenger',
        name: 'Messenger',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/messenger.svg',
        url: 'https://www.facebook.com/dialog/send?link={{url}}',
      },
      {
        id: 'whatsapp',
        name: 'WhatsApp',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/whatsapp.svg',
        url: 'https://wa.me/?text={{url}}',
      },
      {
        id: 'telegram',
        name: 'Telegram',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/telegram.svg',
        url: 'https://t.me/share/url?url={{url}}',
      },
      {
        id: 'viber',
        name: 'Viber',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/viber.svg',
        url: 'https://www.addtoany.com/add_to/viber?linkurl={{url}}',
      },
      {
        id: 'message',
        name: 'Message',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/message.svg',
        url: 'https://www.addtoany.com/add_to/sms?linkurl={{url}}',
      },
      {
        id: 'gmail',
        name: 'Gmail',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/gmail.svg',
        url: 'https://mail.google.com/mail/?view=cm&fs=1&to=&body={{url}}',
      },
    ],
  },
  communication: {
    id: 'communication',
    titleKey: 'shared.share.social.communication_title',
    values: [
      {
        id: 'teams',
        name: 'Teams',
        iconUrl: 'https://assets.fluer.com/assets/img/logo/teams.svg',
        url: 'https://teams.microsoft.com/share?href={{url}}',
      },
    ],
  },
};
